export default (id?: string) => (id ? `e2e-${id}` : 'provide-test-id')
